'use client'

import React, { useEffect } from 'react'
import { CartProvider } from '@/components/cart/CartProvider'
import CartSidebar from '@/components/cart/CartSidebar'
import { useOptimizedCartStore } from '@/stores/optimized-cart-store'
import { ThemeProvider } from 'next-themes'
import { Toaster } from '@/components/ui/toaster'
import { useSiteSettings } from '@/app/[locale]/utils/site-settings-client'


export default function ClientProviders({ children }: { children: React.ReactNode }) {
  
  // Initialize optimized cart store with optimistic updates on mount
  useEffect(() => {
    const initializeOptimizedCart = async () => {
      try {
        const { syncCart, clearError } = useOptimizedCartStore.getState()
        
        // Clear any previous errors
        clearError()
        
        // Initialize cart with optimistic updates
        syncCart()
        
      } catch (error) {
        console.error('[ClientProviders] Error initializing optimized cart:', error)
        useOptimizedCartStore.getState().setError('Failed to initialize cart')
      }
    }
    
    initializeOptimizedCart()
  }, [])

  const { settings } = useSiteSettings()
  const isB2B = !!settings.is_b2b


  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <CartProvider>
        {children}
        <Toaster />
        <CartSidebar isB2B={isB2B} />
        
      </CartProvider>
    </ThemeProvider>
  )
}